module.exports = __webpack_public_path__ + "static/media/iphone3.682f3c02.png";